// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2WL4-","disabled":"FileBtn_disabled__3cVeS","warn":"FileBtn_warn__xolA9","fade":"FileBtn_fade__1x0-Y"};